// extracted by mini-css-extract-plugin
export default {"lottieIcon":"lottieIcon__qN1tH"};